import { render } from "./HoverEditor.vue?vue&type=template&id=3f951d2a&scoped=true"
import script from "./HoverEditor.vue?vue&type=script&lang=ts"
export * from "./HoverEditor.vue?vue&type=script&lang=ts"

import "./HoverEditor.vue?vue&type=style&index=0&id=3f951d2a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3f951d2a"

export default script